import React from "react";
import NotFoundImg from "static/not_found_sad.jpg";

const NotFound = () => (
  <div>
    <h1 style={{ fontFamily: "sans-serif", textAlign: "center" }}>
      404.. Page not found!
    </h1>
    <img
      style={{ margin: "auto", display: "block" }}
      src={NotFoundImg}
      alt="page not found"
    />
  </div>
);

export default NotFound;
